export default {
  id: 130,
  title: 'Target #130 - Letter O',
  url: 'https://cssbattle.dev/play/130',
  colors: ['#926927', '#FFFFFF', '#6D480A'],
  solution:
    '<p a><p b><style>body{background:#926927}p{width:60;height:120;position:fixed;top:54;border:20px solid #fff;border-radius:30px}[a]{left:140;border-color:#6d480a}[b]{left:160}</style>',
}
